/**
 * App environment mode.
 * Controlled by REACT_APP_APP_ENV env variable.
 * Defaults to 'development' — local dev always shows dev UI without extra config.
 *
 * Values:
 *   development — shows dev banner, dev login button, red sidebar header
 *   production  — hides all dev-only UI
 *
 * In Docker: injected at runtime by entrypoint.sh (replaces __REACT_APP_APP_ENV__ placeholder).
 * In ArgoCD: passed via Helm values → frontend.frontend.env.appEnv.
 */
export const APP_ENV = process.env.REACT_APP_APP_ENV ?? 'development';

export const IS_DEV = APP_ENV !== 'production';
